import React, { useState } from 'react';
import { Container, Nav, NavItem, NavLink, TabPane, TabContent
} from 'reactstrap';
import '../index.css';
import '../App.css';
import { useParams } from 'react-router-dom';
import { getUnitByName } from '../shared/unitInfo';
import { RenderTrue } from './unitinfo/TrueComponent';
import { RenderStats } from './unitinfo/StatsComponent';
import { RenderTwoStar, RenderThreeStar, RenderFourStar, RenderFiveStar, RenderAwaken, RenderSuper } from './unitinfo/LoreComponent';
import classNames from 'classnames';
import BackToList from './BackToList';
import { Link } from 'react-router-dom';
import PageMeta from './PageMeta';
import SkeletonImage from './SkeletonImage';

function UnitDetails () {  
    return (
        <Container className="gs-page">
            <div className="gs-page-gutter">
                <UnitHome />
            </div>
        </Container>
    )
}

function UnitHome() {
    //Unit Info
    const selectedUnit = useParams();
    const units = getUnitByName(selectedUnit.unitName); //unitName from Route

    //Tabs
    const [currentTab, setCurrentTab] = useState('2');
    const toggle = tab => {
        if (currentTab !== tab) setCurrentTab(tab);
    }

    if (!units) {
        return (
            <>
                <PageMeta
                    title="Unit Not Found"
                    path={`/units/${encodeURIComponent(selectedUnit.unitName)}`}
                    noIndex
                />
                <BackToList to="/units" label="Back to Units" />
                <div className="gs-empty-state gs-empty-state--inline" role="status">
                    <h2>Unit not found</h2>
                    <p>No unit named “{selectedUnit.unitName}” exists in the database.</p>
                    <div className="gs-empty-state__actions">
                        <Link to="/units" className="gs-btn">Browse Units</Link>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <PageMeta
                title={units.name}
                description={`${units.name} stats, skills, lore, and tier info in the Grand Summoners database.`}
                path={`/units/${encodeURIComponent(units.name)}`}
                image={units.image?.thumbawk || units.image?.thumb5 || '/logo.png'}
            />
            <div className="gs-detail-actions">
                <BackToList to="/units" label="Back to Units" />
                <Link
                    to={`/compare?type=units&a=${encodeURIComponent(units.name)}`}
                    className="gs-btn gs-detail-actions__compare"
                >
                    Compare
                </Link>
            </div>
            <header className="gs-page-intro">
                <h1>{units.name}</h1>
                <p>Select a category to view unit information</p>
            </header>
            <div className="gs-unit-detail">
                <Nav pills justified className="gs-tabs">
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '1' })}
                            onClick={() => { toggle('1') }}
                            >
                            <span style={{userSelect: "none"}}>Lore</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '2' })}
                            onClick={() => { toggle('2') }}>
                            <span style={{userSelect: "none"}}>Stats</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '3' })}
                            onClick={() => { toggle('3') }}>
                            <span style={{userSelect: "none"}}>True Weapon</span>
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={currentTab} >
                    <TabPane tabId="1">
                        <RenderLore unitLore={units.lore} unitImage={units.image} unitName={units.name} unitEvolution={units.evolution} />
                    </TabPane>
                    <TabPane tabId="2">
                        <RenderStats unitStats={units.stats} unitStatsJP={units.statsJP}
                            unitAtt={units.attribute} unitType={units.type} unitSkill={units.skillset} unitSkillJP={units.skillsetJP}
                            unitPassive={units.passive} unitPassiveJP={units.passiveJP} unitSlots={units.slots} unitSlotsJP={units.slotsJP}
                            unitImage={units.image} unitReview={units.review} unitDreamJP={units.dreamJP} unitDreamGL={units.dreamGL} 
                            unitDream={units.dream}
                            />
                    </TabPane>
                    <TabPane tabId="3">
                        <RenderTrue
                            unitTrue={units}
                            trueReview={units.review}
                            onViewStats={() => toggle('2')}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </>
    )
}

function getFirstLoreTab(unitImage) {
    if (unitImage.thumb2) return '2';
    if (unitImage.thumb3) return '3';
    if (unitImage.thumb4) return '4';
    if (unitImage.thumb5) return '5';
    if (unitImage.thumbawk) return '6';
    if (unitImage.thumbsuper) return '7';
    return '5';
}

function RenderLore({unitName, unitLore, unitImage, unitEvolution}) {
    //Tabs
    const [currentTab, setCurrentTab] = useState(() => getFirstLoreTab(unitImage));
    const toggle = tab => {
        if (currentTab !== tab) setCurrentTab(tab);
    }

    return (
        <div className="gs-unit-lore">
            <header className="gs-unit-lore__heading">
                <h2>{unitName}</h2>
                <p>Select an Evolution to view the Lore</p>
            </header>

            <Nav pills justified className="gs-tabs gs-tabs--thumbs">
                { unitImage.thumb2 ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '2' })}
                            onClick={() => { toggle('2') }}>
                            <SkeletonImage
                                src={unitImage.thumb2}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }

                { unitImage.thumb3 ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '3' })}
                            onClick={() => { toggle('3') }}>
                            <SkeletonImage
                                src={unitImage.thumb3}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }

                { unitImage.thumb4 ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '4' })}
                            onClick={() => { toggle('4') }}>
                            <SkeletonImage
                                src={unitImage.thumb4}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }

                { unitImage.thumb5 ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '5' })}
                            onClick={() => { toggle('5') }}>
                            <SkeletonImage
                                src={unitImage.thumb5}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }

                { unitImage.thumbawk ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '6' })}
                            onClick={() => { toggle('6') }}>
                            <SkeletonImage
                                src={unitImage.thumbawk}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }

                { unitImage.thumbsuper ? 
                    <NavItem>
                        <NavLink 
                            className={classNames({ active: currentTab === '7' })}
                            onClick={() => { toggle('7') }}>
                            <SkeletonImage
                                src={unitImage.thumbsuper}
                                alt=""
                                frameClassName="gs-skeleton-frame--detail-thumb"
                                loading="lazy"
                            />
                        </NavLink>
                    </NavItem> 
                    : null
                }
            </Nav>
            <TabContent activeTab={currentTab}>
                { unitImage.thumb2 ? 
                    <TabPane tabId="2">
                        <RenderTwoStar lore={unitLore.evo2} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }

                { unitImage.thumb3 ? 
                    <TabPane tabId="3">
                        <RenderThreeStar lore={unitLore.evo3} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }

                { unitImage.thumb4 ? 
                    <TabPane tabId="4">
                        <RenderFourStar lore={unitLore.evo4} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }

                { unitImage.thumb5 ? 
                    <TabPane tabId="5">
                        <RenderFiveStar lore={unitLore.evo5} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }

                { unitImage.thumbawk ? 
                    <TabPane tabId="6">
                        <RenderAwaken lore={unitLore.evoawk} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }

                { unitImage.thumbsuper ? 
                    <TabPane tabId="7">
                        <RenderSuper lore={unitLore.evosuper} unitImage={unitImage} unitEvo={unitEvolution} />
                    </TabPane>
                    : null            
                }
            </TabContent>
        </div>
    )
}

export default UnitDetails;
